import { AlertTriangle } from "lucide-react";

/**
 * Banner mostrato quando una lista è aperta con ?ritardo=true, con link per
 * rimuovere il filtro. Stesso linguaggio visivo (rosso) del riquadro Ritardi
 * in Dashboard.
 */
export function RitardoBanner({ onRemove }: { onRemove: () => void }) {
  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-[#ef4444]/30 bg-[#ef4444]/5 px-4 py-2.5 text-sm">
      <span className="flex items-center gap-2 font-medium text-[#dc2626]">
        <AlertTriangle className="h-4 w-4" aria-hidden="true" />
        Stai vedendo solo i record in ritardo.
      </span>
      <button type="button" onClick={onRemove} className="shrink-0 font-semibold text-primary hover:underline">
        Rimuovi filtro
      </button>
    </div>
  );
}
